export default {
    login: {
        name: 'Логин',
        password: 'Пароль',
        enter: 'Войти',
        error: 'Ошибка входа',
    },
};
